import { render, staticRenderFns } from "./EditPermissionDialog.vue?vue&type=template&id=4e498932&scoped=true"
import script from "./EditPermissionDialog.vue?vue&type=script&lang=js"
export * from "./EditPermissionDialog.vue?vue&type=script&lang=js"
import style0 from "./EditPermissionDialog.vue?vue&type=style&index=0&id=4e498932&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e498932",
  null
  
)

export default component.exports